import { render, staticRenderFns } from "./consulta-de-precio.vue?vue&type=template&id=73d047a0"
import script from "./consulta-de-precio.vue?vue&type=script&lang=js"
export * from "./consulta-de-precio.vue?vue&type=script&lang=js"
import style0 from "./consulta-de-precio.vue?vue&type=style&index=0&id=73d047a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports